import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize('G-GL4W0PF7Q2', {
    debug: process.env.NODE_ENV === 'development', // Enable debug mode in development
  });
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  ReactGA.event({
    action: action,
    category: category,
    label: label,
    value: value,
  });
};

// Track prayer-related events
export const trackPrayerEvent = (eventType, details = {}) => {
  ReactGA.event({
    action: eventType,
    category: 'Prayer',
    label: details.prayerIndex ? `Prayer ${details.prayerIndex}` : 'General',
    value: details.prayerIndex || 0,
  });
};

// Track user interactions
export const trackUserInteraction = (interactionType, details = {}) => {
  ReactGA.event({
    action: interactionType,
    category: 'User Interaction',
    label: details.label || 'General',
    value: details.value || 0,
  });
};

// Track donation events
export const trackDonationEvent = (eventType, details = {}) => {
  ReactGA.event({
    action: eventType,
    category: 'Donation',
    label: details.label || 'General',
    value: details.value || 0,
  });
};
